import React from "react";
import { ComponentI } from "../../../../types";
import Card from "../../../../componentLibrary/Card";
import ExternalTextEditor from "../../../../componentLibrary/ExternalTextEditor";

export default function TextContentCard({
  component,
  handleContentChange,
}: {
  component: ComponentI;
  handleContentChange: (id: string, field: string, value: string) => void;
}) {
  const handleChange = (value: string) => {
    handleContentChange(component._id, "text", value);
  };

  return (
    <Card>
      <ExternalTextEditor
        value={component.content.text}
        handleChange={handleChange}
        placeholder="Enter the text content here..."
      />
    </Card>
  );
}
